module.exports = __webpack_public_path__ + "img/The Logo.46626157.png";